"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Utilitná funkcia pre konverziu sekúnd na hodíny a minúty
 * @param {number} - Čas v sekundách
 * @param {boolean} - Prepínač skrátenia času. Nezobrazenie hodín ak sa rovnajú nule
 * @returns {string} - Čas prevedený na text
 * @example
 * ```javascript
 * import calcTime from 'utilities/lib/calcTime';
 * const timeInSeconds = 1234;
 *
 * console.log(calcTime(timeInSeconds)); // 00h 20m
 * console.log(calcTime(timeInSeconds, true)); // 20m
 * ```
 */
function calcTime(time, shorten) {
    if (shorten === void 0) { shorten = false; }
    if (typeof time !== 'number' || Number.isNaN(time)) {
        throw Error("Time must be number in seconds. Received: \"" + time + "\"");
    }
    var t = Math.abs(time);
    var hours = Math.floor(t / 3600);
    var minutes = Math.floor((t % 3600) / 60);
    if (shorten) {
        // shorter version of time (without unneeded zeros)
        if (hours === 0) {
            return "" + (time < 0 ? '-' : '') + minutes + "m";
        }
        return "" + (time < 0 ? '-' : '') + hours + "h " + (minutes < 10 ? "0" + minutes : minutes) + "m";
    }
    else {
        return "" + (time < 0 ? '-' : '') + (hours < 10 ? "0" + hours : hours) + "h " + (minutes < 10 ? "0" + minutes : minutes) + "m";
    }
}
exports.default = calcTime;
